import { createStore } from 'stimulus-store';

export const deviceTypeStore = createStore({
    name: 'deviceTypeStore',
    type: Object,
    initialValue: {}
});